/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Failedtopublishlisting3Inputs */

const en_failedtopublishlisting3 = /** @type {(inputs: Failedtopublishlisting3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to publish listing`)
};

const de_failedtopublishlisting3 = /** @type {(inputs: Failedtopublishlisting3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ort konnte nicht veröffentlicht werden`)
};

/**
* | output |
* | --- |
* | "Failed to publish listing" |
*
* @param {Failedtopublishlisting3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const failedtopublishlisting3 = /** @type {((inputs?: Failedtopublishlisting3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Failedtopublishlisting3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_failedtopublishlisting3(inputs)
	return de_failedtopublishlisting3(inputs)
});
export { failedtopublishlisting3 as "failedToPublishListing" }